import styled from 'styled-components';
import { black, gradientGreenDark, gradientGreenLight, grey, white } from 'styles/Colors';

const Span = styled.span`
  display: block;
  position: relative;
`;

export const NotSaved = styled.span`
  padding: 1rem;
  background: linear-gradient(90deg, rgba(208, 2, 27, 1) 0%, rgba(231, 208, 211, 1) 100%);
  padding: 1px;
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
`;

export const FirstRow = styled.div`
  display: flex;
`;

export const PlaySequenceNumber = styled(Span)`
  margin-left: auto;
  color: ${grey};
  position: relative;
  top: -5px;
`;

export const TooltipText = styled(Span)`
  font-family: Lato;
  font-size: 12px;
  visibility: hidden;
  width: 90px;
  background-image: linear-gradient(92deg, #414141, rgba(65, 65, 65, 0.82));
  color: ${white};
  text-align: center;
  border-radius: 5px;
  padding: 2spx;
  position: absolute;
  z-index: 1;
  right: 15px;
  top: 6px;
`;

export const Warning = styled.div`
  top: -8px;
  position: relative;
  margin-left: auto;
  &:hover ${TooltipText} {
    visibility: visible;
  }
`;

export const Type = styled(Span)`
  font-family: Lato;
  font-size: 13px;
  line-height: 1.23;
  letter-spacing: 0.5px;
  color: ${black};
  opacity: 1;
  margin-top: 1px;
`;

export const Speed = styled(Span)`
  font-family: Oswald;
  font-size: 28px;
  font-weight: 500;
  line-height: 1.09;
  letter-spacing: 0.5px;
  color: ${black};
`;

export const SpeedUnit = styled(Span)`
  margin-left: 2px;
  font-family: Oswald;
  font-size: 15px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0.5px;
  color: ${black};
  margin-top: 13px;
`;

export const StyledBpPlay = styled.div`
  overflow: hidden;
  position: relative;
  border-radius: 5px;
  height: 56px;
  cursor: pointer;
  padding: 5px;
  margin-bottom: 10px;
  display: block;
  background: ${white};

  &.even {
    background-image: linear-gradient(103deg, #f1f1f1, #f9f9f9);
  }
  &.odd {
    border: 1px solid #f1f1f1f1;
  }

  &:last-of-type {
    margin-bottom: 0px;
  }
  &.selected {
    background-image: linear-gradient(278deg, #449fff, #057dff);
    ${Speed},
    ${Type},
    .score,
    ${SpeedUnit} {
      color: ${white};
      opacity: 1;
    }
    ${FirstRow} {
      ${PlaySequenceNumber} {
        color: ${white};
      }
    }
  }

  &.animate {
    &::before {
      content: '';
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      background: linear-gradient(291.3deg, ${gradientGreenLight} 0%, ${gradientGreenDark} 99.45%);
      animation: fadeOutAnimation 2s 1 cubic-bezier(1, 0.1, 0.6, 0);
      z-index: 0;
    }
    opacity: 1;
    @keyframes fadeOutAnimation {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
`;
